import SecureStore from './secureStore';
import { Roles } from '../constants';

const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d])[a-zA-Z].{7,}$/;

export function isMasterAdmin() {
  return SecureStore.getRole() === Roles.MASTER_ADMIN;
}

export function isTecSupport() {
  return SecureStore.getRole() === Roles.TEC_SUPPORT;
}

export function isCompanyAdmin() {
  return SecureStore.getRole() === Roles.COMPANY_ADMIN;
}

export function isDivisionAdmin() {
  return SecureStore.getRole() === Roles.DIVISION_ADMIN;
}

export function isCommunityProjectAdmin() {
  return SecureStore.getRole() === Roles.COMMUNITY_PROJECT_ADMIN;
}

export function isCompanyUser() {
  return SecureStore.getRole() === Roles.COMPANY_USER;
}

export function isSalesUser() {
  return SecureStore.getRole() === Roles.SALES_USER;
}

export function isAdmin() {
  return isMasterAdmin() || isTecSupport() || isCompanyAdmin();
}

export function isMasters() {
  return isMasterAdmin() || isTecSupport();
}

export function isStrongPassword(pwd) {
  return STRONG_PASSWORD_REGEX.test(pwd);
}
